import React, { useState } from "react";
import {
  Dialog,
  ListItem,
  List,
  Toolbar,
  Slide,
  Grid,
  DialogTitle,
} from "@material-ui/core";
import { TransitionProps } from "@material-ui/core/transitions";
import { ButtonSubmit } from "../../../../Components";
import { TextField2 } from "../../../../Components/Field";
import { useStyles } from "./GroupDocument.style";
import { useIntl } from "react-intl";
import { SelectCheck } from "../../../../Components/Select/SelectCheck";
import { useDispatch, useSelector } from "react-redux";
import UserGroupServicesApi from "../../../../Redux/Actions/UserGroups/UserGroupAction";
import UserSevicesApi from "../../../../Redux/Actions/UserAction";
import { useApiValidationSnackbar } from "../../../../Components/Snackbar/SnackbarAlert";
import { useSnackbar } from "notistack";
const Transition = React.forwardRef(function Transition(
  props: TransitionProps & { children?: React.ReactElement },
  ref: React.Ref<unknown>
) {
  return <Slide direction="up" ref={ref} {...props} />;
});
interface createGrpupProps {
  handleClose: () => void;
  open: boolean;
  addUserClose: () => void;
  addopen?: any;
  group: any;
  forceReload: () => void;
  setReload: () => void;
}
export const CreateGroup = ({
  handleClose,
  open,
  addUserClose,
  addopen,
  group,
  forceReload,
  setReload,
}: createGrpupProps) => {
  const [input, setInput] = React.useState<any>({
    name: "",
    descrioption: "",
    addUserGroup: [],
  });
  const [userId, setUserId] = useState<any>([]);
  const { formatMessage } = useIntl();
  const classes = useStyles();
  const dispatch: any = useDispatch();
  const { notifySuccess, ErrorMessage } = useApiValidationSnackbar();
  const { enqueueSnackbar } = useSnackbar();
  const { userList, apiToken, currentUser, addUserFormGroup } = useSelector(
    (state: any) => ({
      userList: state?.UserReducer?.userList,
      apiToken: state?.UserReducer?.apiToken,
      currentUser: state?.UserReducer?.currentUser,
      addUserFormGroup: state?.UserGroupReducer?.addUserFormGroup,
    })
  );
  const CreateGroup = () => {
    const userParam = {
      name: input?.name,
      description: input?.descrioption,
      customerid: currentUser?.customerId,
    };
    let customerId = currentUser?.customerId;
    let fileName: any = "fillgroupName";
    let description: any = "description";
    if (!input.name) {
      ErrorMessage(userList, fileName);
    } else if (!input?.descrioption) {
      ErrorMessage(userList, description);
    } else {
      dispatch(
        UserGroupServicesApi?.createUserGroup(
          userParam,
          customerId,
          apiToken,
          notifySuccess,
          ErrorMessage
        )
      );
      setReload();
      handleClose();
      setTimeout(() => {
        updateFile();
        addUserClose();
      }, 500);
    }
  };
  const selectHandlChange = (e: any, newMember: any) => {
    let user: any = [...userId];
    newMember?.map((x: any) => user?.push(x.id));
    setUserId(user);
  };
  const addusersGroup = () => {
    let data: any;
    if (userId?.length > 2) {
      data = userId?.filter(function (item: any, index: any, inputArray: any) {
        return inputArray?.indexOf(item) == index;
      });
    } else {
      data = userId;
    }
    const addUsers = {
      userGroupId: group?.id,
      userIds: data,
    };
    dispatch(
      UserGroupServicesApi.assignUsersGroup(addUsers, apiToken, enqueueSnackbar)
    );
    setReload();
    setTimeout(() => {
      updateFile();
      addUserClose();
      setUserId([]);
    }, 500);
  };
  const updateFile = () => {
    if (addUserFormGroup?.error?.message) {
      const internalError: any = "internalError";
      ErrorMessage(addUserFormGroup, internalError);
    } else {
      dispatch(
        UserSevicesApi.UserListData(
          currentUser?.customerId,
          apiToken,
          enqueueSnackbar
        )
      );
      forceReload();
    }
  };
  return (
    <div>
      <Dialog
        open={open}
        onClose={handleClose}
        TransitionComponent={Transition}
      >
        <DialogTitle id="alert-dialog-title" style={{ width: "100%" }}>
          {formatMessage({
            id: "group.user.createGroup",
            defaultMessage: "Create Group",
          })}
        </DialogTitle>
        <List>
          <ListItem>
            <Grid>
              <Grid container spacing={2}>
                <Grid item xs={4} className={classes.g_name}>
                  {formatMessage({
                    id: "group.user.permission.groups",
                    defaultMessage: "Permission group",
                  })}
                  :&nbsp;
                </Grid>
                <Grid item xs={8}>
                  <TextField2
                    onChange={(str: string) =>
                      setInput({ ...input, name: str })
                    }
                    placeholder={formatMessage({
                      id: "group.user.permission.group.placeholder",
                      defaultMessage: "Add name of permission group",
                    })}
                  />
                </Grid>
              </Grid>
              <Grid container spacing={2}>
                <Grid item xs={4} className={classes.g_name1}>
                  {formatMessage({
                    id: "group.user.description",
                    defaultMessage: "Description",
                  })}{" "}
                  :
                </Grid>
                <Grid item xs={8}>
                  <TextField2
                    onChange={(str: string) =>
                      setInput({ ...input, descrioption: str })
                    }
                    placeholder={formatMessage({
                      id: "group.user.description",
                      defaultMessage: "Group Description",
                    })}
                  />
                </Grid>
              </Grid>
            </Grid>
          </ListItem>
        </List>
        <Toolbar>
          <ButtonSubmit
            text={"model.title.cancel"}
            onClick={handleClose}
            className={classes.padding5}
          />
          <Grid container justifyContent={"flex-end"}>
            <ButtonSubmit
              text={"component.mtable.save"}
              onClick={CreateGroup}
            />
          </Grid>
        </Toolbar>
      </Dialog>

      <Dialog
        open={addopen}
        onClose={addUserClose}
        TransitionComponent={Transition}
      >
        <DialogTitle id="alert-dialog-title" style={{ width: 380 }}>
          {formatMessage({id:"group.user.addTo"},{groupname:group?.name})}
        </DialogTitle>
        <List>
          <ListItem>
            <SelectCheck
              onChange={selectHandlChange}
              options={
                userList?.errors
                  ? []
                  : userList?.filter(
                      (item: any) =>
                        item?.userGroupId == null && item?.status == "Active"
                    )
              }
              placeholder={formatMessage({
                id: "group.user.add",
                defaultMessage: "User",
              })}
            />
          </ListItem>
        </List>
        <Toolbar>
          <ButtonSubmit
            text={"model.title.cancel"}
            onClick={addUserClose}
            className={classes.padding5}
          />
          <Grid container justifyContent={"flex-end"}>
            <ButtonSubmit text={"model.title.save"} onClick={addusersGroup} />
          </Grid>
        </Toolbar>
      </Dialog>
    </div>
  );
};
